module.exports = __webpack_public_path__ + "static/media/picture-(76).dc3631be.JPG";